export default __webpack_public_path__ + "static/media/partner_club.4136985d.svg";